/**
 * Collection PLP: equalize .aspect-ratio--square heights per visual row
 * inside Convermax product lists.
 *
 * Finds:
 *   .product-list.product-list--collection.product-list--with-sidebar.card.cmRepeater_items
 *
 * Loops direct children. First item starts a row. From the 2nd on, if the
 * vertical offset (offsetTop) matches the previous item, they share the
 * same horizontal line and stay in the row; otherwise the previous row is
 * equalized and a new row starts.
 *
 * Per item: img max-height = item width (square-ish cap).
 * Per row: measure img height inside .aspect-ratio--square, apply the max
 * height to every .aspect-ratio--square in that row.
 */
(function () {
  var LIST_SEL =
    '.product-list.product-list--collection.product-list--with-sidebar.card.cmRepeater_items';
  var SQUARE_SEL = '.aspect-ratio--square';
  var IMG_SEL = 'img';
  var ROW_TOLERANCE = 2;
  var scheduled = false;
  var observedLists = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function isDisplayed(el) {
    if (!el || !el.isConnected) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function directItemChildren(list) {
    var items = [];
    var children = list.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.nodeType !== 1) continue;
      if (!isDisplayed(child)) continue;
      items.push(child);
    }
    return items;
  }

  function resetSquareHeight(square) {
    square.style.height = '';
    square.style.minHeight = '';
  }

  function resetImageMaxHeight(img) {
    if (img) img.style.maxHeight = '';
  }

  /**
   * Cap each image at the item's width so tall images don't exceed a square.
   */
  function applyImageMaxHeightFromItemWidth(item) {
    var square = item.querySelector(SQUARE_SEL);
    if (!square) return null;

    var img = square.querySelector(IMG_SEL);
    var width = item.getBoundingClientRect().width;
    if (!width) width = item.offsetWidth;

    if (img && width > 0) {
      img.style.maxHeight = Math.ceil(width) + 'px';
    } else if (img) {
      resetImageMaxHeight(img);
    }

    return square;
  }

  function imageHeight(square) {
    var img = square.querySelector(IMG_SEL);
    if (img) {
      var ih = img.getBoundingClientRect().height;
      if (ih > 0) return ih;
      if (img.naturalHeight && img.clientWidth && img.naturalWidth) {
        return (img.naturalHeight / img.naturalWidth) * img.clientWidth;
      }
    }
    return square.getBoundingClientRect().height;
  }

  function equalizeRow(rowItems) {
    if (!rowItems.length) return;

    var squares = [];
    var maxH = 0;
    var i;
    var square;
    var h;
    var img;

    for (i = 0; i < rowItems.length; i++) {
      square = rowItems[i].querySelector(SQUARE_SEL);
      if (!square) continue;
      resetSquareHeight(square);
      img = square.querySelector(IMG_SEL);
      resetImageMaxHeight(img);
      squares.push(square);
    }

    // Item width → img max-height, then measure for row equalization.
    for (i = 0; i < rowItems.length; i++) {
      applyImageMaxHeightFromItemWidth(rowItems[i]);
    }

    for (i = 0; i < squares.length; i++) {
      h = imageHeight(squares[i]);
      if (h > maxH) maxH = h;
    }

    if (maxH <= 0) return;

    var px = Math.ceil(maxH) + 'px';
    for (i = 0; i < squares.length; i++) {
      squares[i].style.height = px;
    }
  }

  function equalizeList(list) {
    var items = directItemChildren(list);
    if (!items.length) return;

    // First element starts the current horizontal line.
    var row = [items[0]];
    var prevTop = items[0].offsetTop;
    var i;

    for (i = 1; i < items.length; i++) {
      var top = items[i].offsetTop;
      // Same horizontal line → same offsetTop as previous item.
      if (Math.abs(top - prevTop) <= ROW_TOLERANCE) {
        row.push(items[i]);
      } else {
        equalizeRow(row);
        row = [items[i]];
        prevTop = top;
      }
    }

    equalizeRow(row);
  }

  function equalizeAll() {
    var lists = document.querySelectorAll(LIST_SEL);
    for (var i = 0; i < lists.length; i++) {
      equalizeList(lists[i]);
      observeList(lists[i]);
    }
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      equalizeAll();
    });
  }

  function observeList(list) {
    if (!window.MutationObserver) return;
    if (observedLists) {
      if (observedLists.has(list)) return;
      observedLists.add(list);
    } else if (list.getAttribute('data-fcd-row-equalize-observed') === '1') {
      return;
    } else {
      list.setAttribute('data-fcd-row-equalize-observed', '1');
    }

    var observer = new MutationObserver(function () {
      schedule();
    });
    observer.observe(list, { childList: true, subtree: true });
  }

  function onImageEvents(root) {
    root.addEventListener(
      'load',
      function (event) {
        var t = event.target;
        if (t && t.tagName === 'IMG' && t.closest(LIST_SEL)) schedule();
      },
      true
    );
  }

  function start() {
    equalizeAll();
    onImageEvents(document);

    var page = document.querySelector('#cm-collection-page') || document.body;
    if (window.MutationObserver) {
      var bootObserver = new MutationObserver(function () {
        if (document.querySelector(LIST_SEL)) schedule();
      });
      bootObserver.observe(page, { childList: true, subtree: true });
    }

    window.addEventListener('resize', schedule);
    document.addEventListener('cm:results', schedule);
    document.addEventListener('cm:ready', schedule);
    document.addEventListener('convermax:results', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
